(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/init.js');

'use strict';

svs.map_of_winners.app = new Marionette.Application({
  region: '#mowMapRegion',

  onStart: function() {
    this.showView(new svs.map_of_winners.views.WinMaps());
  }
});

if (document.getElementById('mowMapRegion')) {
  svs.map_of_winners.app.start();
}


 })(window);